module.exports = __webpack_public_path__ + "img/builder-26.e63a4759.jpg";